import { savedOrderDetailsTotalStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderDetailsTotalStyles.cartTotal = {
    subtotalLabel: {
        css: css`
        font-size: 14px;
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.main")};
        font-weight: 700;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
            font-size: 12px;
        `,
            null,
            null,
            null,
            null,
        ])}
`,
    },
    subtotalValue: {
        css: css`
        font-size: 14px;
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.main")};
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
            font-size: 12px;
        `,
            null,
            null,
            null,
            null,
        ])}
`,
    },
}